<template>
    <component :is="markRaw(MarketingShow)" v-bind="props" />
    <Meta :title="'Resources | ' + manufacturer.name" />
</template>

<script setup>
import {markRaw} from "vue";
import MarketingShow from '../../../Themes/Marketing/Pages/Catalog/Resources/Show.vue';
import {Meta} from "@/Components";

const props = defineProps(['manufacturer','manufacturers','resources','crumbs','series']);
</script>
